var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-page',{staticClass:"page",attrs:{"bg":"white","tabbar":""}},[_c('div',{staticClass:"page-container about",domProps:{"innerHTML":_vm._s(_vm.data)}}),_c('tabbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }